type TSection = 'drawer' | 'list' | 'get';

type TListAction = 'list' | 'get';

type TUpsertAction = 'create' | 'update' | 'delete' | 'toggle';

type TAction = TListAction | TUpsertAction;

const sectionName: Record<TSection, string> = {
  drawer: 'el banner',
  get: 'el banner',
  list: 'los banners',
};

const actionVerb: Record<TAction, string> = {
  create: 'creaba',
  update: 'editaba',
  delete: 'eliminaba',
  toggle: 'cambiaba el estado de',
  list: 'recuperaban',
  get: 'obtenía',
};

export const getUnexpectedErrorMessage = (section: TSection, action: TAction) => {
  const errorMessage = `Error inesperado mientras se ${actionVerb[action]} ${sectionName[section]}`;

  return errorMessage;
};
